import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownJobTitleContext } from "./form-dropdown-job-title.context";

export interface FormDropdownJobTitleProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownJobTitle<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownJobTitleProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newJobTitle,
    mappedJobTitle,
    isCreating,
    setSidebar,
    setFilter,
    setNewJobTitle,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownJobTitleContext();
  
  return (
    <div className="job-title">
      {newJobTitle && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new jobTitle</h2>
          <p>
            You are creating a new jobTitle. Please, fill the fields to create a
            new jobTitle and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="JobTitle Name"
              value={newJobTitle.name}
              onChange={(e: any) =>
                setNewJobTitle({ ...newJobTitle, name: e.target.value })
              }
            />
            <InputText
              placeholder="JobTitle Description"
              value={newJobTitle.description}
              onChange={(e: any) =>
                setNewJobTitle({ ...newJobTitle, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="Position"
        options={ mappedJobTitle }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your position"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownJobTitle;